(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karly-newsletter-capture"]) return;
  try {
    
  (() => {
    const storageKey = 'karly_newsletter_popup_v1';
    const sessionKey = 'karly_newsletter_popup_dismissed';
    const root = document.querySelector('[data-karly-newsletter]');
    if (!root) return;

    const prepareConfirmation = (confirmation) => {
      document.documentElement.classList.add('karly-confirmation-page');
      document.body.classList.add('karly-confirmation-page');
      const confirmationModal = root.querySelector('[data-newsletter-modal]');
      if (confirmationModal) confirmationModal.hidden = true;
      document.documentElement.style.overflow = '';
      let ancestor = confirmation.parentElement;
      while (ancestor && ancestor !== document.body) {
        ancestor.classList.add('karly-confirmation-ancestor');
        ancestor = ancestor.parentElement;
      }
      const heading = confirmation.querySelector('h1');
      const paragraph = confirmation.querySelector('p');
      if (heading && root.dataset.confirmationHeading) heading.textContent = root.dataset.confirmationHeading;
      if (paragraph && root.dataset.confirmationText) paragraph.textContent = root.dataset.confirmationText;
      confirmation.setAttribute('data-karly-confirmation-ready', 'true');
    };

    const confirmation = document.querySelector('.shopify-email-marketing-confirmation__container');
    if (confirmation) prepareConfirmation(confirmation);

    if (!confirmation) {
      const confirmationObserver = new MutationObserver(() => {
        const insertedConfirmation = document.querySelector('.shopify-email-marketing-confirmation__container');
        if (!insertedConfirmation) return;
        prepareConfirmation(insertedConfirmation);
        confirmationObserver.disconnect();
      });
      confirmationObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => confirmationObserver.disconnect(), 8000);
    }

    const modal = root.querySelector('[data-newsletter-modal]');
    if (!modal) return;

    if (confirmation) {
      modal.hidden = true;
      return;
    }

    const dialog = modal.querySelector('[role="dialog"]');
    const closeButtons = modal.querySelectorAll('[data-newsletter-close]');
    const success = modal.querySelector('[data-newsletter-success]');
    let previousFocus = null;

    const readState = () => {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey)) || {};
      } catch (error) {
        return {};
      }
    };

    const writeState = (state) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (error) {
        return;
      }
    };

    const openModal = () => {
      previousFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-opening');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => dialog.focus(), 20);
    };

    const closeModal = () => {
      modal.hidden = true;
      modal.classList.remove('is-opening');
      document.documentElement.style.overflow = '';
      if (previousFocus instanceof HTMLElement) previousFocus.focus();

      const now = Date.now();
      if (success) {
        writeState({ status: 'submitted', until: now + 31536000000 });
      } else {
        try {
          window.sessionStorage.setItem(sessionKey, 'true');
        } catch (error) {
          return;
        }
      }
    };

    closeButtons.forEach((button) => button.addEventListener('click', closeModal));

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;

      const focusable = [...dialog.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.hasAttribute('disabled'));
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (success) {
      writeState({ status: 'submitted', until: Date.now() + 31536000000 });
      openModal();
      return;
    }

    const popupEnabled = root.dataset.popupEnabled === 'true';
    const designMode = root.dataset.designMode === 'true';
    const state = readState();
    const registered = state.status === 'submitted' && state.until && state.until > Date.now();
    let dismissedThisSession = false;
    try {
      dismissedThisSession = window.sessionStorage.getItem(sessionKey) === 'true';
    } catch (error) {
      dismissedThisSession = false;
    }
    if (!popupEnabled || registered || dismissedThisSession) return;

    const delay = designMode ? 100 : Number(root.dataset.popupDelay || 800);
    window.setTimeout(openModal, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-companion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('karly-scroll-companion')) {
    customElements.define('karly-scroll-companion', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.initialized = true;
        this.current = 0;
        this.target = 0;
        this.frame = null;
        this.updateTarget = this.updateTarget.bind(this);
        this.renderFrame = this.renderFrame.bind(this);
        window.addEventListener('scroll', this.updateTarget, { passive: true });
        window.addEventListener('resize', this.updateTarget, { passive: true });
        this.updateTarget();
        requestAnimationFrame(() => this.classList.add('is-ready'));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateTarget);
        window.removeEventListener('resize', this.updateTarget);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      updateTarget() {
        const maximum = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
        this.target = Math.min(Math.max(window.scrollY / maximum, 0), 1);
        if (!this.frame) this.frame = requestAnimationFrame(this.renderFrame);
      }

      renderFrame() {
        this.current += (this.target - this.current) * 0.16;
        const start = window.innerWidth < 750 ? 104 : 132;
        const bottomSpace = window.innerWidth < 750 ? 82 : 88;
        const travel = Math.max(window.innerHeight - start - this.offsetHeight - bottomSpace, 0);
        const y = start + travel * this.current;
        const tilt = Math.max(-5, Math.min(5, (this.target - this.current) * 70));
        this.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0) rotate(${tilt.toFixed(2)}deg)`;

        if (Math.abs(this.target - this.current) > 0.0005) {
          this.frame = requestAnimationFrame(this.renderFrame);
        } else {
          this.current = this.target;
          this.frame = null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
